import { pagePathFromSegments } from '@/helpers/page-tree'

export type PageReference = {
  slug?: string
  sys?: {
    id: string
  }
  parentPage?: PageReference
}

const MAX_DEPTH = 4

export function segmentsFromPageNextLeaf(page: PageReference): string[] | null {
  const segments: string[] = []
  const visited = new Set<string>()

  let current: PageReference | null = page
  let depth = 0

  while (current && depth < MAX_DEPTH) {
    const slug = current.slug?.trim()
    if (!slug) return null

    // Guard against cycles if Contentful data gets weird.
    const id = current.sys?.id
    if (id) {
      if (visited.has(id)) return null
      visited.add(id)
    }

    segments.push(slug)
    current = (current.parentPage as PageReference | null) ?? null
    depth += 1
  }

  if (depth >= MAX_DEPTH) return null

  return segments.reverse()
}

export function hrefFromMediaBlockPage(locale: string, page: PageReference): string | null {
  if (!page) return null

  const segments = segmentsFromPageNextLeaf(page)
  if (!segments) return null

  return pagePathFromSegments(locale, segments)
}
